import enRaw from '../locales/en.json';
import elRaw from '../locales/el.json';

export type Language = 'en' | 'el';

export const SUPPORTED_LANGUAGES: { code: Language; label: string; flag: string }[] = [
  { code: 'en', label: 'EN', flag: '🇬🇧' },
  { code: 'el', label: 'ΕΛ', flag: '🇬🇷' },
];

// Both locale files are JSON arrays with a single object — unwrap to get the translations object
const en = Array.isArray(enRaw) ? enRaw[0] : enRaw;
const el = Array.isArray(elRaw) ? elRaw[0] : elRaw;

type TranslationsType = typeof en;

// Deep merge: fills missing keys in `target` with values from `fallback`
function deepMerge<T extends Record<string, unknown>>(fallback: T, target: Record<string, unknown>): T {
  const result: Record<string, unknown> = { ...fallback };
  for (const key of Object.keys(fallback)) {
    const fb = fallback[key];
    const tg = target[key];
    if (tg === undefined || tg === null) {
      result[key] = fb;
    } else if (typeof fb === 'object' && !Array.isArray(fb) && fb !== null && typeof tg === 'object' && !Array.isArray(tg) && tg !== null) {
      result[key] = deepMerge(fb as Record<string, unknown>, tg as Record<string, unknown>);
    } else {
      result[key] = tg;
    }
  }
  return result as T;
}

const translations: Record<Language, TranslationsType> = {
  en,
  el: deepMerge(en, el as Record<string, unknown>),
};

export function getTranslations(language: Language): TranslationsType {
  return translations[language] ?? translations.en;
}
